<template>
    <div>
        <form ref="form">
            <div class="flex items-center py-md" @click="toggled = ! toggled">
                <checkbox-input
                    v-model="completed"
                    v-tooltip.top.start="unableToCompleteMessage"
                    :disabled="disabled || ! task.can_be_completed"
                >
                    {{ task.body }}
                </checkbox-input>

                <div class="ml-auto flex items-center">
                    <task-completed-by
                        :key="task.id"
                        :task="task"
                        class="mr-md"
                    />

                    <font-awesome-icon
                        v-if="toggled"
                        icon="chevron-up"
                    />
                    <font-awesome-icon
                        v-else
                        icon="chevron-down"
                    />
                </div>
            </div>

            <div v-show="toggled" class="pb-md">
                <textarea-input
                    v-model="text"
                    v-tooltip.top.start="unableToCompleteMessage"
                    name="text"
                    :disabled="disabled || ! task.can_be_completed"
                />
            </div>
        </form>
    </div>
</template>

<script>
    import BaseType from './BaseType';
    export default {
        extends: BaseType,
        data() {
            return {
                text: this.task.data.text || '',
                toggled: false,
            };
        },
        computed: {
            disabled() {
                return this.text.length < 1 && ! this.completed;
            },
        },
        watch: {
            completed(isCompleted) {
                if (this.ignoreEvent) {
                    this.ignoreEvent = false;

                    return;
                }

                if (isCompleted) {
                    return this.complete();
                }

                this.uncomplete();
            },
        },
        methods: {
            async complete() {
                this.ignoreEvent = true;
                this.completed = await this.completeTask({ text: this.text });
            },
            async uncomplete() {
                this.ignoreEvent = true;
                this.completed = ! await this.unCompleteTask();
                if (this.completed) {
                    this.text = '';
                }
            },
        },
    };
</script>